var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"sportWrapper"},[_c('div',{staticClass:"sportLeft"},[_c('LeftCode'),_c('LeftLeague'),_c('LeftGym')],1),_c('div',{staticClass:"sportCenter"},[_c('CenterTop'),_c('Map'),_c('CenterBottom')],1),_c('div',{staticClass:"sportRight"},[_c('RightVideo'),_c('RightGuide'),_c('RightActivity')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }